import { string, object, number, array, bool, mixed } from "yup";

export const EmptyForm = {
    candidate: {
        name: "",
        company: "",
        url: "",
        orgSize: "",
        member: "",
    },
    experience: {
        birthYear: "",
        experience: "",
        ecommerceDirectorExperience: "",
        yearsInCurrentCompany: "",
    },
    submitter: {
        name: "",
        email: "",
        phone: "",
    },
    invoice: {
        name: "",
        address: {
            street: "",
            postalCode: "",
            city: "",
        },
        nip: "",
    },
    agreements: {
        notifyAboutCompetition: false,
        notifyAboutOtherActivities: false,
        termsAndConditions: false,
        // dataAutenticity: false,
        // releaseImage: false,
    },
    logo: {
        vector: null, // cdr, eps, ai, psd
        raster: null, // png, jpeg
    },
    submissions: [],
};

export const EmptySubmission = {
    key: -1,
    category: "",
    title: "",
    description: "",
    presentation: null, // pdf
};

export const Categories = [
    "FMCG",
    "Fashion",
    "Tech / RTV / AGD",
    "Dom i Ogród",
    "Edukacja / Kultura",
    "Beauty / Kosmetyki",
    "Sport / Hobby / Turystyka",
    "Omnichannel",
    "Crossborder e-commerce",
    "B2B e-commerce",
    "Innowacje"
];

export const FormSchema = object().shape({
    candidate: object()
        .shape({
            name: string().required(),
            company: string().required(),
            url: string().required(),
            orgSize: string().required().oneOf(["mały", "średni-duży"]),
            member: string().required().oneOf(["tak", "nie"]),
        })
        .required(),
    experience: object()
        .shape({
            birthYear: number().required().min(1900).max(2002),
            experience: number().required().min(0).max(50), // todo: cross validation using refs
            ecommerceDirectorExperience: number().required().min(0).max(50), // todo: cross validation using refs
            yearsInCurrentCompany: number().required().min(0).max(50), // todo: cross validation using refs
        })
        .required(),
    submitter: object()
        .shape({
            name: string().required(),
            email: string().required().email(),
            phone: string().required(),
        })
        .required(),
    invoice: object()
        .shape({
            name: string().required(),
            address: object().shape({
                street: string().required(),
                postalCode: string()
                    .required()
                    .matches(/^\d{2}-\d{3}$/),
                city: string().required(),
            }),
            nip: string()
                .required()
                .matches(/^\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3})$/),
        })
        .required(),
    agreements: object()
        .shape({
            notifyAboutCompetition: bool().required().oneOf([true]),
            notifyAboutOtherActivities: bool(),
            termsAndConditions: bool().required().oneOf([true]),
            // dataAuthenticity: bool().required().oneOf([true]),
            // releaseImage: bool().required().oneOf([true]),
        })
        .required(),
    logo: object()
        .shape({
            vector: mixed().required(), // todo:
            // raster: mixed().required(), // todo:
        })
        .required(),
    submissions: array()
        .of(
            object().shape({
                key: number().required(),
                category: string().required().oneOf(Categories),
                title: string().required(),
                description: string().required().min(100).max(1000),
                presentation: mixed().required(), // todo:
            })
        )
        .required()
        .min(1)
        .max(3),
});
